import { RulesetDisposition } from 'libs/tools/src/lib/rule-editor/models/ruleset-disposition.model';

export interface DocutechGlobalModel {
  canPreviewDisclosure: boolean;
  canOrderDisclosure: boolean;
  isDisclosuresResolution: boolean;
  docPackageVendor: DocPackageVendor;
  previewRequestId: string;
  orderRequestId: string;
  deliveryMethod: string;
  rulesetDisposition: RulesetDisposition;
}

export enum DocPackageVendor {
  Auto = 'Auto',
  Docutech = 'Docutech',
  Ids = 'Ids',
}
